<template>
  <div class="main-content wide">
    <div class="wrap">
      <sidebar-left v-if="showSidebar && !isMobile" />
      <div :class="['main-block', { 'with-sidebar': showSidebar }]">
        <div class="content">
          <form-header
            :title="getPageTitle"
            :description="getDescription"
            :steps-title="stepsTitle"
            :steps="steps"
            :hide-back-link="isIntroStep"
            :link-title="$t('buttons.stepBack')"
            :show-sub-items="isIntroStep"
            :columns="2"
            @goBack="backFn"
          />

          <component
            :is="getStep()"
            :form="activeStep"
            :info-box-description="infoBoxDescription"
            :info-box-c-t-a="infoBoxCTA"
          />
        </div>

        <info-block
          v-if="!showSidebar"
          :list="list"
          :note="note"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    components: {
      'sidebar-left': () => import(/* webpackChunkName: "sidebar-left" */ 'components/Sidebar/Sidebar'),
      intro: () => import(/* webpackChunkName: "forms-intro" */ 'containers/Pages/Assistance/Intro'),
      'validation': () => import(/* webpackChunkName: "forms-validation" */ 'components/Forms/PnrValidation'),
      'info-block': () => import(/* webpackChunkName: "sidebar-info-block" */ 'components/Sidebar/InfoBlock'),
      'form-header': () => import(/* webpackChunkName: "forms-form-header" */ 'components/Forms/FormHeader'),
      'guidance': () => import(/* webpackChunkName: "forms-assistance-guidance" */ 'containers/Pages/Assistance/Guidance'),
      'wheelchair-own': () => import(/* webpackChunkName: "forms-assistance-own-wheelchair" */ 'containers/Pages/Assistance/OwnWheelChair'),
      'wheelchair-airport': () => import(/* webpackChunkName: "forms-assistance-own-wheelchair" */ 'containers/Pages/Assistance/AirportWheelChair'),
      'other': () => import(/* webpackChunkName: "forms-assistance-other" */ 'containers/Pages/Assistance/Other'),
    },
    computed: {
      ...mapState('device', [
        'deviceType'
      ]),
      ...mapState('assistance/generic', [
        'activeStep',
        'activeItem',
        'list',
        'note',
        'pageTitle',
        'description',
        'stepsTitle',
        'steps',
        'info',
        'backFn'
      ]),

      ...mapState('sidebar', [
        'pleaseNoteTitle',
        'pleaseNoteText',
      ]),
      ...mapState('assistance/validation', [
        'infoBoxDescription',
        'infoBoxCTA'
      ]),
      isIntroStep () {
        return this.activeStep === 'intro'
      },
      isMobile () {
        return this.deviceType === 'mobile'
      },
      showSidebar () {
        return this.isIntroStep
      },
      getPageTitle () {
        return this.showItem('title') ? this.activeItem.title : this.pageTitle
      },
      getDescription () {
       return this.showItem('description') ? this.activeItem.description : this.description
      }
    },
    mounted() {
      this.$store.commit('assistance/files/setMaxLength', 99)
      this.$store.commit('assistance/files/setCheckEachFileSize', false)
    },
    methods: {
      showItem (key) {
        if (this.activeItem !== null) {
          return typeof this.activeItem[`${key}`] !== "undefined"
        }
        return false
      },
      getStep () {
        if (!this.activeStep) {
          return 'intro'
        }

        if (['intro', 'validation', 'guidance', 'wheelchair-own', 'wheelchair-airport', 'other'].includes(this.activeStep)) {
          return this.activeStep
        }
      }
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  .main-content {
    padding: 20px 0 20px;

    @include bp-tablet-only {
      padding-top: 37px;
    }

    @include bp-mf-desktop {
      padding-top: 40px;
    }

    .wrap {
      display: flex;
      flex-direction: column;
      @include clearfix();

      @include bp-mf-desktop {
        display: block;
      }
    }
  }

  .main-block {
    display: flex;
    flex-direction: column;
    order: 0;
    padding: 0 0 28px;
    margin-top: 0;
    width: 100%;

    @include bp-mf-tablet {
      padding: 0 26px 26px;
      margin-top: -11px;
    }

    @include bp-mf-desktop {
      padding: 0 0 48px;
      flex-direction: row;
      justify-content: space-between;
      margin-top: -21px;
    }

    &.with-sidebar {
      @include bp-mf-tablet {
        margin-top: 0;
      }

      @include bp-desktop-small {
        position: relative;
        top: 0;
      }

      @include bp-mf-desktop {
        position: relative;
        float: left;
        vertical-align: top;
        width: 66%;

        .content {
          width: 100%;
        }
      }
    }
  }

  .content {
    @include bp-mf-desktop {
      width: 58%;
    }
  }
</style>
